module.exports = __webpack_public_path__ + "static/img/sm_15.5a092a1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/sm_15.png
// module id = 18Yu
// module chunks = 0